import {Modal} from "@renta-apps/athenaeum-react-components";
import {
    MassProductStepDescriptionProps
} from "@/pages/ReturnedMassProductPage/components/MassProductStepDescription/MassProductStepDescriptionProps";
import ImageProvider from "@/providers/ImageProvider";
import ToolsImageInput from "@/components/ToolsImageInput/ToolsImageInput";

const MassProductStepDescription = ({ modalRef, onModalClose, description, pictures } : MassProductStepDescriptionProps) => {

    return (
        <Modal id={"addMaintenanceReasonModal"} ref={modalRef} onClose={async () => onModalClose()} title={description} >
            <ToolsImageInput readonly pictures={pictures} imageUrl={image => ImageProvider.getImageUrl(image)} />
        </Modal>
    )
}


export default MassProductStepDescription;